import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy } from "lucide-react";
import { api, errMsg } from "@/lib/api";

const fmt = (iso) => new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" });

// Active private links with their codes; revoke any time
export const ShareLinks = ({ refresh }) => {
  const [links, setLinks] = useState([]);
  useEffect(() => { api.get("/therapist-share").then((r) => setLinks(r.data)).catch(() => {}); }, [refresh]);
  if (!links.length) return null;
  const copy = (l) => { navigator.clipboard?.writeText(`${window.location.origin}${l.path}`); toast.success("Link copied. Share the code separately."); };
  const revoke = async (l) => { try { await api.delete(`/therapist-share/${l.id}`); setLinks((x) => x.map((y) => (y.id === l.id ? { ...y, revoked: true } : y))); toast.success("Link turned off"); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div className="mm-card p-5" data-testid="tshare-links">
      <h2 className="font-bold mb-3">My private links</h2>
      <div className="space-y-2">
        {links.map((l) => (
          <div key={l.id} className="mm-soft p-3 flex flex-wrap items-center gap-3 text-sm" data-testid={`tshare-link-${l.id}`}>
            <div className="flex-1 min-w-[12rem]">
              <div className="font-semibold">Last {l.range_days} days · code <span className="font-mono tracking-widest" data-testid={`tshare-link-code-${l.id}`}>{l.code}</span></div>
              <div className="text-mm-muted text-xs">{l.revoked ? "Turned off" : l.locked ? "Locked after wrong codes" : `Expires ${fmt(l.expires_at)}`} · opened {l.views}×</div>
            </div>
            {!l.revoked && <>
              <button onClick={() => copy(l)} className="mm-chip" data-testid={`tshare-link-copy-${l.id}`}><Copy size={13} />Copy link</button>
              <button onClick={() => revoke(l)} className="mm-chip !text-mm-error" data-testid={`tshare-link-revoke-${l.id}`}>Turn off</button>
            </>}
          </div>
        ))}
      </div>
    </div>
  );
};
